<app-website-details-web *ngIf="website.type == websiteTypes.RentalWebsite" [website]="website">
</app-website-details-web>
<app-website-details-engine *ngIf="website.type == websiteTypes.BookingEngine" [website]="website">
</app-website-details-engine>
<app-website-details-portal *ngIf="website.type == websiteTypes.GuestPortal" [website]="website">
</app-website-details-portal>

<app-website-details-rentals [website]="website"> </app-website-details-rentals>
